import { createHeader, createSubHeader, createBulletPoint } from "./componentHelpers"

export const renderCertificateSection = (certificateExperiences) => {
  if (!certificateExperiences || certificateExperiences.length === 0) {
    return []
  }

  return [
    ...createHeader("LICENSES AND CERTIFICATIONS"),
    ...certificateExperiences
      .filter((experience) => experience)
      .flatMap((experience) => {

        const title = experience.title || 'TITLE'
        const issuer = experience.issuer || 'ISSUER'
        const endDate = experience.endDate || ''
        const bulletPoints = experience.bulletPoints || []

        return [
          createSubHeader(title, issuer, "", "", endDate),
          bulletPoints.map(b => createBulletPoint(b)),
        ].flat()
      }),
  ]
}
